import React from 'react';
import { Row, Col, Link } from '@gravity-ui/uikit';
import './styles/index.css';

export function Footer() {
    const date = new Date();

    return (
        <footer className="Footer">
            <Row space={5}>
                <Col
                    s="9"
                    style={{
                        textAlign: 'left',
                    }}
                >
                    <span>
                        Trade secrets of Yandex LLC. 16, Lev Tolstoy Str., Moscow, Russia, 119021
                    </span>
                </Col>
                <Col
                    s="3"
                    style={{
                        textAlign: 'right',
                    }}
                >
                    <span>
                        © {date.getFullYear()} «
                        <Link href="https://ya.ru/" target="_blank" rel="noopener noreferrer">
                            Yandex
                        </Link>
                        »
                    </span>
                </Col>
            </Row>
        </footer>
    );
}
